document.addEventListener('DOMContentLoaded', () => {
    // Get all <img> tags
    const images = document.getElementsByTagName('img');

    // Loop through all <img> tags and prevent right-click on each
    for (let img of images) {
        img.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });
    }
});